export class DeleteBoardError {
  public static readonly type = '[Project/Manager/List] DeleteBoardErrorEffect';
  constructor(public readonly error: Error) {}
}
